import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { AgGridReact } from 'ag-grid-react';
import axios from 'axios';
import { Select, DatePicker } from 'antd';
import { PageHeader, Button } from 'antd';
import { pageSectionTitle } from '../util/Style';
import RowPopup from './RowPopup';
import { erpApiurl } from '../stores/APIEndpoints';

const { Option } = Select;

class ReferrerSampleStatus extends Component {
  state = {
    rowData: [],
    selectedRowData: null,
    isPopupVisible: false,
    PopupArry:[],
    selectedInterval: "3" // Default value
  };

 
  gridRef = React.createRef();

  componentDidMount() {
    this.fetchData("3");
  }

  autoSizeColumns = () => {
    if (this.gridApi) {
      this.gridApi.sizeColumnsToFit();
    }
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
  };

  onCellClicked = (event) => {
    console.log("Cell clicked: ", event);
    // You can perform actions based on the cell click event here
  };

  onRowClicked = (event) => {
    this.fetchPopupdata(event.data.ReferrerId)
    console.log("Row clicked: ", event);
    this.setState({
      selectedRowData: event.data,
      isPopupVisible: true
    });

  };

  onPopupClose = () => {
    this.setState({
      isPopupVisible: false
    });
  };
  onChangeInterval = (value) => {
    console.log("GetPivotedData",value);
    this.fetchData(value);
    this.setState({ selectedInterval: value });
    
}
  onBtExport = async () => {
    if (this.gridRef.current && this.gridRef.current.api) {
      await this.gridRef.current.api.exportDataAsCsv();
    } else {
      console.error('Grid reference or API is not available yet.');
    }
  };

  fetchData = async (value) => {
    try {
      const response = await axios.get(erpApiurl+'/api/ReferrerSampleStatus/GetPivotedData?filter='+value);
      this.setState({ rowData: response.data });
      this.autoSizeColumns();
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  fetchPopupdata = async (ReferrerId) => {
    try {
      const response = await axios.get(`${erpApiurl}/api/referrerSampleStatus/GetSampleStatustRegistrationDatas?ReferrerId=${ReferrerId}&days=${this.state.selectedInterval}`);
      this.setState({ PopupArry: response.data });
   
    } catch (error) {
      console.error('Error fetchPopupdata:', error);
    }
  };


  render() {
    const { rowData, isPopupVisible,PopupArry } = this.state;

    

    const isDateInFormat = (columnName, format) => {
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
      return dateRegex.test(columnName);
    };
    
    const formatDateColumnHeader = (columnName) => {
      // Split the column name to get the year, month, and day parts
      const [year, month, day] = columnName.split('-');
      
      // Create a Date object with the extracted year, month, and day
      const date = new Date(year, month - 1, day); // Month is 0-indexed in Date object
      
      // Get the day, month, and year components from the date
      const formattedDay = ('0' + date.getDate()).slice(-2); // Ensure leading zero if needed
      const formattedMonth = ('0' + (date.getMonth() + 1)).slice(-2); // Month is 0-indexed, so add 1
      const formattedYear = date.getFullYear().toString().slice(-2); // Get last two digits of the year
      
      // Concatenate the components with '-' separator to get the formatted date
      const formattedDate = `${formattedDay}`;
      
      return formattedDate;
    };

    // Column definitions
    const columnDefs = [
      { headerName: 'BId', field: 'branchid',width: 90  },
      { headerName: 'Branch', field: 'BranchName' },
      { headerName: 'Ref', field: 'ReferrerName' },
      { headerName: 'M.kt', field: 'MarketingExecutiveName',width: 130 },
      { headerName: 'col', field: 'collectionboyname',width: 130 },
      { headerName: 'Type', field: 'Type',width: 130  },
      { headerName: 'Mobile', field: 'Mobile',width: 150  },
      ...(rowData.length > 0 ? Object.keys(rowData[0])
      .filter((key) => !['ReferrerName', 'BranchName', 'MarketingExecutiveName',
       'collectionboyname', 'ReferrerId','branchid','Type','Mobile','Total'].includes(key)).map((column) => ({
        headerName: isDateInFormat(column, 'yyyy-MM-dd') ? formatDateColumnHeader(column) : column, // Check if the field represents a date in the specified format
        field: column,
        width: 100
      })) : []),
      { headerName: 'Tot', field: 'Total',width: 130  },
    ];

    return (
      <PageHeader style={{}}>
         {isPopupVisible && <RowPopup rowData={PopupArry} onClose={this.onPopupClose} />}
        <h1>{pageSectionTitle(this.props.title)}</h1>
        <Select defaultValue={this.state.selectedInterval} style={{ width: 120 }} onChange={this.onChangeInterval}>
          <Option value="3">3d</Option>
          <Option value="5">5d</Option>
          <Option value="10">10d</Option>
          <Option value="20">20d</Option>
          <Option value="30">1mo</Option>
        </Select>
        <Button onClick={this.onBtExport} shape="round" style={{ background: "rgb(27,160,97)", color: "white" }}>Export CSV</Button>
        <div className="ag-theme-alpine" style={{ height: 1000, width: '100%' }}>
          <AgGridReact
            ref={this.gridRef}
            rowData={rowData}
            columnDefs={columnDefs}
            defaultColDef={{
              sortable: true,
              resizable: true,
              filter: true,
              flex: 1
            }}
            onGridReady={this.onGridReady}
            onCellClicked={this.onCellClicked}
            onRowClicked={this.onRowClicked}
            rowHeight={30}
          />
        </div>
       

      </PageHeader>
    );
  }
}

export default observer(ReferrerSampleStatus);
